import { Button } from "@chakra-ui/react";
import type { ButtonProps } from "@chakra-ui/react";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {LegacyRef} from "react";

export interface CancelButtonProps extends ButtonProps {
  innerRef?: LegacyRef<HTMLButtonElement>;
}

export const CancelButton = ({className, innerRef, ...props}:CancelButtonProps) => {
    
    const {t} = useTranslation("buttons");
    return (
        <Button ref={innerRef}
                type="button"
                className={className}
                leftIcon={<FontAwesomeIcon icon={faTimes}/>}
                aria-label={t("cancel")}
                {...props} >{t("cancel")}</Button>
    );
};